import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';
import { Button } from './Button';

// ============================================
// EMPTY STATE
// ============================================

interface EmptyStateProps {
  icon: React.ReactNode;
  title: string;
  description?: string;
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  className = ''
}) => (
  <div className={`flex flex-col items-center justify-center py-16 px-4 ${className}`}>
    <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mb-4">
      {icon}
    </div>
    <p className="text-lg font-medium text-slate-600 mb-1">{title}</p>
    {description && (
      <p className="text-sm text-slate-400 text-center max-w-sm">{description}</p>
    )}
  </div>
);

// ============================================
// ERROR STATE
// ============================================

interface ErrorStateProps {
  message: string;
  title?: string;
  onRetry?: () => void;
  className?: string;
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  message,
  title = 'Une erreur est survenue',
  onRetry,
  className = ''
}) => (
  <div className={`flex flex-col items-center justify-center py-16 px-4 bg-white rounded-2xl border border-red-200 ${className}`}>
    <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mb-4">
      <AlertCircle className="w-8 h-8 text-red-500" />
    </div>
    <p className="text-lg font-medium text-slate-700 mb-2">{title}</p>
    <p className="text-sm text-slate-500 text-center max-w-sm mb-4">{message}</p>
    {onRetry && (
      <Button color="primary" onClick={onRetry}>
        <RefreshCw size={16} />
        Réessayer
      </Button>
    )}
  </div>
);
